import React from 'react';
import { useTranslation } from 'react-i18next';
import LoadingSpinner from '../LoadingSpinner';
import { useStyles } from './styles';

const OrderInfo = props => {
  const classes = useStyles();
  const { t } = useTranslation('pointOfService');

  const { orderItemId, orderCreated, orderStatus, orderPrice } = props;
  const showLoadingSpinner = Object.values(props).some(prop => !prop);

  if (showLoadingSpinner) return <LoadingSpinner />;

  return (
    <ul className={classes.orderInfoList}>
      <li>
        {t('orderInfo.orderId')}
        {orderItemId}
      </li>
      <li>
        {t('orderInfo.created')}
        {orderCreated}
      </li>
      <li>
        {t('orderInfo.status')}
        {orderStatus}
      </li>
      <li>
        {t('orderInfo.orderAmount')}
        {orderPrice}
      </li>
    </ul>
  );
};

export default OrderInfo;
